/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ElevatedUserDto } from '../../models/elevated-user-dto';
import { ElevateUserResponse } from '../../models/elevate-user-response';

export interface CreateElevatedUser$Params {
      body: ElevatedUserDto
}

export function createElevatedUser(http: HttpClient, rootUrl: string, params: CreateElevatedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ElevateUserResponse>> {
  const rb = new RequestBuilder(rootUrl, createElevatedUser.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ElevateUserResponse>;
    })
  );
}

createElevatedUser.PATH = '/api/v2/elevatedUsers';
